<template lang="pug">
  .lista-solicitud-vacaciones.contenedor-interno
    .title
      span Mis vacaciones tomadas
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close

    .body
      table.table.is-striped.is-bordered
        thead
          //- th Id
          th Fecha
          //- th Hasta
          th Retorno
          //- th Dias
          th De la solicitud
        tbody(
          name="table-row"
          is="transition-group"
        )
          tr.row-table(
            v-for="(o,index) in vacaciones"
            :key="index"
          )
            //- td {{ o.id }}
            td
              .td-wrapper.hint--top(:aria-label="'Vacaciones: ' + o.id")
                .dates-wrapper
                  span {{ o.desde }}
                  span.hide-break-1 &nbsp;-&nbsp;
                  span {{ o.hasta }}
            td
              .td-wrapper
                span {{ o.retorno }}&nbsp;
                span.email ({{ o.dias }} días)
            td {{ o.idSolicitud }}
      loading(v-if="isLoading")
</template>

<script>
import { apiGet, notify } from '../util/general'
export default {
  name: 'lista_vacaciones_component',
  data () {
    return {
      vacaciones: [],
      isLoading: true
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {}
      apiGet(vm, '/vacaciones/vacaciones', obj, function (data) {
        if (data.lista.length === 0) {
          vm.$emit('close')
        }
        vm.vacaciones = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-interno
    .close
      position absolute
      right 5px
      top 5px
      cursor pointer
      i
        font-size 16px

    .title
      padding-left: 10px
      padding-right: 10px
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .contenedor-acciones
    display flex
    .but  ton
      flex 1
      margin 0  px 5px

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6  d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .lista-sol  icitud-vacaciones
    position relative

  td
    .email
      font-size 12px
      color #9a9a9a

  .show-break-1
    display none

  // .hide-break-1
  //   display initial

  @media (max-width 694px)
    td
      text-align: center
      vertical-align: middle
      .contenedor-acciones
        flex-direction: column
        .button
          margin-bottom 5px
          &:last-child
            margin-bottom 0px

  @media (max-width 583px)
    .table
      font-size 12px
      td
        text-align: center
        vertical-align: middle
      .td-wrapper
        display flex
        justify-content: center
        align-items: center
        flex-direction: column

        .dates-wrapper
          display: flex
          flex-direction: column
    .show-break-1
      display initial
    .hide-break-1
      display none
</style>



// WEBPACK FOOTER //
// Component_Lista_Vacaciones.vue?a4130a62